{{#if siteLink}}
<div class="public-user-fields">
  <div class="public-user-field">
    <span class="user-field-name">{{siteLink.name}}</span>:
    <span class="user-field-value">{{{siteLink.link}}}</span>
  </div>
</div>
{{/if}}